/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Grid, Icon, MenuItem, Paper, Select, TextField, useTheme } from '@mui/material';
import { Environment } from '../../environment';
import { AutoCompleteFuncionario01 } from '../../forms';

interface IFerramentasDaListagemProps {
  textoDaBusca?: string;
  textoDoSelect?: string;
  mostrarInputBusca?: boolean;
  textonome?: string;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  mostrarInputBasicSelect?: boolean
  aoClicarEmNovo?: () => void;
  aoMudarTextoDoFun?: (novoTextoselect: string) => void;
}
export const FerramentasDaListagemEmpFun: React.FC<IFerramentasDaListagemProps> = ({
  textoDaBusca = '',
  textoDoSelect = '',
  textonome = '',
  aoMudarTextoDeBusca,
  aoMudarTextoDoSelect,
  mostrarInputBusca = false,
  mostrarInputBasicSelect = false,
  aoClicarEmNovo,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  aoMudarTextoDoFun,
}) => {
  const theme = useTheme();

  const handleuuidFun = (uuid: string | undefined) => {
    if (uuid != null) {
      aoMudarTextoDoFun?.(uuid);
    }
  };

  return (
    <Box
      gap={1}
      marginX={3}
      padding={1}
      paddingX={2}
      display="flex"
      alignItems="center"
      //  height={theme.spacing(5)}
      component={Paper}
    >
      <Grid container item direction="row" spacing={1}>
        {mostrarInputBasicSelect && (
          <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
            <Select
              size="small"
              fullWidth
              value={textoDoSelect}
              onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
            >
              <MenuItem value={'todos'}>todos</MenuItem>
              <MenuItem value={'descontar'}>descontar</MenuItem>
              <MenuItem value={'descontado'}>descontado</MenuItem>
            </Select>

          </Grid>
        )}
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          {mostrarInputBusca && (
            <Box sx={{ minWidth: 350 }} >
              <AutoCompleteFuncionario01
                isExternalLoading={false}
                uuidfun={handleuuidFun}
              />
            </Box>

          )}
        </Grid>
        <Grid item xs={2} sm={1} md={2} lg={1} xl={1}>
          <Box flex={1} display="flex" justifyContent="end">
            {mostrarBotaoNovo && (
              <Button
                fullWidth
                color='primary'
                disableElevation
                variant='contained'
                onClick={aoClicarEmNovo}
                endIcon={<Icon>add</Icon>}
              >{textoBotaoNovo}</Button>
            )}
          </Box>
        </Grid>
      </Grid>

    </Box>
  );
};